export default class FileTypeSetting {
    constructor(fileType: string, displayName: string) {
        this.fileType = fileType;
        this.displayName = displayName;
    }
    fileType?: string;
    displayName?: string;
}